import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { SignInGate } from './components/SignIn';
import { AdminHome, CompanyLayout, SettingsRedirect } from './admin/CompanyLayout';
import { Conversations } from './pages/Conversations';
import { LeadJourney } from './pages/LeadJourney';
import { RepScoring } from './pages/RepScoring';
import { Rescue } from './pages/Rescue';
import { Revive } from './pages/Revive';
import { Overview } from './pages/Overview';
import { Settings } from './pages/Settings';
import { Integrations } from './pages/Integrations';
import { Leaderboard } from './pages/Leaderboard';
import { JourneySetup } from './pages/JourneySetup';
import { Coaching } from './pages/Coaching';
import { AskRex } from './pages/AskRex';
import { LeadScoring } from './pages/LeadScoring';
import { LeadSources, Placeholder } from './pages/Placeholder';
import { AdminLayout } from './admin/AdminLayout';
import { Companies } from './admin/Companies';
import { CompanyWizard } from './admin/CompanyWizard';
import { CompanyDetail } from './admin/CompanyDetail';

// Phase 1 ships Conversations and the Lead journey. Other screens follow the handoff's build order.
const LATER: { path: string; title: string; phase: string; blurb: string }[] = [
];

export function App() {
  return (
    <SignInGate>
      <AppRoutes />
    </SignInGate>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminHome owner={<Companies />} />} />
        <Route path="new" element={<CompanyWizard mode="add" />} />
        <Route path="companies/:id/fix" element={<CompanyWizard key="fix" mode="fix" />} />
        <Route path="companies/:id" element={<CompanyLayout />}>
          <Route index element={<Navigate to="team" replace />} />
          <Route path="team" element={<Settings />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="journey" element={<JourneySetup />} />
          <Route path="rep-scoring" element={<RepScoring />} />
          <Route path="lead-scoring" element={<LeadScoring />} />
          <Route path="ai" element={<CompanyDetail />} />
        </Route>
      </Route>
      <Route element={<Shell />}>
        <Route index element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/rescue" element={<Rescue />} />
        <Route path="/revive" element={<Revive />} />
        {/* Setup lives in Admin; these short addresses open the current company's setup. */}
        <Route path="/settings" element={<SettingsRedirect />} />
        <Route path="/settings/:tab" element={<SettingsRedirect />} />
        {/* Old addresses, from before setup moved under Settings. */}
        <Route path="/integrations" element={<Navigate to="/settings/integrations" replace />} />
        <Route path="/journey-setup" element={<Navigate to="/settings/journey" replace />} />
        <Route path="/rep-scoring" element={<Navigate to="/settings/rep-scoring" replace />} />
        <Route path="/lead-scoring" element={<Navigate to="/settings/lead-scoring" replace />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/ask" element={<AskRex />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/conversations/:leadId" element={<LeadJourney />} />
        <Route path="/lead-sources" element={<LeadSources />} />
        {LATER.map((p) => (
          <Route key={p.path} path={p.path} element={<Placeholder title={p.title} phase={p.phase} blurb={p.blurb} />} />
        ))}
        <Route path="*" element={<Navigate to="/conversations" replace />} />
      </Route>
    </Routes>
  );
}
